import React from 'react';
import { useLang } from '@/i18n/LanguageContext';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const EnrollmentProcess = () => {
  const { t } = useLang();
  const ep = t.enrollmentProcess;
  const navigate = useNavigate();

  const steps = [
    { num: '1', text: ep.step1 },
    { num: '2', text: ep.step2 },
    { num: '3', text: ep.step3 }
  ];

  return (
    <section className="py-20 bg-slate-50 relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none" style={{ backgroundImage: 'radial-gradient(circle at 2px 2px, black 1px, transparent 0)', backgroundSize: '32px 32px' }}></div>
      
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 tracking-tight">{ep.title}</h2>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-20 relative">
          {/* Connector Line for Desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-teal-200/50 z-0"></div>
          
          {steps.map((step, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.5 }}
              className="flex flex-col items-center text-center relative z-10"
            >
              <div className="w-24 h-24 rounded-full bg-teal-400 text-white flex items-center justify-center text-5xl font-black mb-6 shadow-xl shadow-teal-900/20 ring-8 ring-slate-50">
                {step.num}
              </div>
              <p className="text-lg md:text-xl font-semibold text-slate-700 max-w-[200px]">
                {step.text}
              </p>
            </motion.div>
          ))}
        </div>

        <div className="text-center mt-4">
          <button onClick={() => navigate('/application')} className="inline-flex items-center justify-center px-10 py-4 text-lg font-bold text-white transition-all duration-200 bg-brand-primary border border-transparent rounded-full hover:bg-brand-primary/90 hover:scale-105 hover:shadow-lg hover:shadow-brand-primary/30">
            {t.nav?.apply || 'Apply Now'}
          </button>
        </div>
      </div>
    </section>
  );
};

export default EnrollmentProcess;
